jQuery(document).ready(function ($) {
  const $answers = $(".faq-answer").css({ overflow: "hidden" });

  // Measure natural heights using scrollHeight + padding
  $answers.each(function () {
    const $el = $(this);
    // Temporarily make visible to measure
    $el.removeClass("hidden").css({ display: "flex", height: "auto", visibility: "hidden", opacity: 1 });

    // Get scrollHeight + bottom padding
    const natural = $el[0].scrollHeight;
    const paddingBottom = parseFloat($el.css('padding-bottom')) || 0;
    const totalHeight = natural + paddingBottom;

    $el.data("height", totalHeight);
    // Restore hidden state
    $el.css({ height: 0, display: "none", visibility: "visible", opacity: 0 }).addClass("hidden");
  });

  $(".faq-question-wrapper").on("click", function () {
    const $btn = $(this);
    const $faqItem = $btn.closest(".faq-item");
    const $faqPair = $faqItem.parent();
    const $faqAnswer = $faqPair.find(".faq-answer");

    // Toggle classes
    $faqItem.toggleClass("active");

    // Toggle aria-expanded
    const expanded = $btn.attr("aria-expanded") === "true";
    $btn.attr("aria-expanded", expanded ? "false" : "true");

    const isOpen = $faqAnswer.is(":visible");

    if (isOpen) {
      // Close - animate to 0 including padding and opacity
      const currentHeight = $faqAnswer.outerHeight();
      $faqAnswer.css({ height: currentHeight, opacity: 1 }).stop(true, false).animate({
        height: 0,
        paddingTop: 0,
        paddingBottom: 0,
        opacity: 0
      }, 280, function () {
        $(this).removeClass("active").addClass("hidden").css({
          display: "none",
          paddingTop: "",
          paddingBottom: "",
          opacity: 0
        });
      });
    } else {
      // Open
      const height = $faqAnswer.data("height");
      $faqAnswer
        .removeClass("hidden")
        .addClass("active")
        .css({ display: "flex", height: 0, paddingTop: 0, paddingBottom: 0, opacity: 0 })
        .show()
        .stop(true, false)
        .animate({
          height: height,
          paddingTop: "1rem",
          paddingBottom: "1.25rem",
          opacity: 1
        }, 300, function () {
          // Allow responsive content after open
          $(this).css({ height: "auto" });
        });
    }
  });

  // Recalculate stored heights on window resize (debounced)
  let rT;
  $(window).on("resize", function () {
    clearTimeout(rT);
    rT = setTimeout(function () {
      $answers.each(function () {
        const $el = $(this);
        const wasVisible = $el.is(":visible");
        $el.removeClass("hidden").css({ display: "flex", height: "auto", visibility: "hidden" });
        const natural = $el[0].scrollHeight;
        const paddingBottom = parseFloat($el.css('padding-bottom')) || 0;
        const totalHeight = natural + paddingBottom;
        $el.data("height", totalHeight);
        if (!wasVisible) {
          $el.css({ height: 0, display: "none", visibility: "visible", opacity: 0 }).addClass("hidden");
        } else {
          $el.css({ height: "auto", display: "flex", visibility: "visible", opacity: 1 });
        }
      });
    }, 150);
  });
});


jQuery(document).ready(function ($) {
  // Calculate and store the natural height for each dropdown answer
  $(".dropdown-answer").each(function () {
    const $this = $(this);
    $this.css({ display: "flex", height: "auto", visibility: "hidden" });
    const totalHeight = $this.outerHeight(true);
    $this.data("height", totalHeight);
    $this.css({ display: "none", height: 0, visibility: "visible" });
  });

  $(".dropdown-question-wrapper").on("click", function () {
    const answerId = $(this).attr("aria-controls");
    const $dropdownAnswer = $("#" + answerId);
    const $dropdownItem = $(this).closest(".dropdown-item");

    $dropdownItem.toggleClass("active");

    if ($dropdownAnswer.is(":visible")) {
      $dropdownAnswer
        .removeClass("active")
        .animate({ height: 0 }, 300, function () {
          $(this).hide();
        });
    } else {
      const height = $dropdownAnswer.data("height");
      $dropdownAnswer
        .addClass("active")
        .css({ display: "flex", height: 0 })
        .show()
        .animate({ height: height }, 300);
    }
  });
});

// jQuery(document).ready(function ($) {
//   // Wrap images in Gutenberg gallery with <a> if not already wrapped
//   $(".wp-block-gallery figure.wp-block-image img").each(function () {
//     var $img = $(this);
//     if (!$img.parent().is("a")) {
//       var src = $img.attr("src");
//       $img.wrap('<a href="' + src + '"></a>');
//     }
//   });

//   // Initialize LightGallery
//   $(".wp-block-gallery").each(function () {
//     if (!$(this).hasClass("lg-initialized")) {
//       lightGallery(this, {
//         selector: "figure.wp-block-image > a",
//         download: false,
//         thumbnail: true,
//       });
//       $(this).addClass("lg-initialized");
//     }
//   });
// });


document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.wp-block-button__link[rel~="noopener"]').forEach(function(link) {
    link.setAttribute('target', '_blank');
  });

    document.querySelectorAll('a[rel*="noopener"]').forEach(function(link) {
    if (!link.hasAttribute('target')) {
      link.setAttribute('target', '_blank');
    }
  });
});
